/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsjoinerstitle2Inputs */

const en_statsjoinerstitle2 = /** @type {(inputs: Statsjoinerstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who joins plans (7 days)`)
};

const de_statsjoinerstitle2 = /** @type {(inputs: Statsjoinerstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer Plänen beitritt (7 Tage)`)
};

/**
* | output |
* | --- |
* | "Who joins plans (7 days)" |
*
* @param {Statsjoinerstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsjoinerstitle2 = /** @type {((inputs?: Statsjoinerstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsjoinerstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsjoinerstitle2(inputs)
	return de_statsjoinerstitle2(inputs)
});
export { statsjoinerstitle2 as "statsJoinersTitle" }